
import PhotoAvatar from "./PhotoAvatar";
import { Button } from "@/components/ui/button";
import { Upload, Loader2 } from "lucide-react";

interface PhotoAvatarRowProps {
  photos: string[];
  onSetMainPhoto: (index: number) => void;
  onRemovePhoto: (photo: string, index: number) => void;
  onAddPhoto: () => void;
  uploading: boolean[];
  canAddMore: boolean;
  disabled?: boolean;
}

const PhotoAvatarRow = ({ 
  photos, 
  onSetMainPhoto, 
  onRemovePhoto, 
  onAddPhoto, 
  uploading, 
  canAddMore, 
  disabled = false 
}: PhotoAvatarRowProps) => {
  return (
    <div className="w-full">
      <div className="flex items-center space-x-4 overflow-x-auto pb-2">
        {/* Photo Avatars */}
        {photos.map((photo, index) => (
          <PhotoAvatar
            key={index}
            photo={photo}
            index={index}
            isMain={index === 0} // First photo is always main
            onSetMain={() => onSetMainPhoto(index)}
            onRemove={() => onRemovePhoto(photo, index)}
          />
        ))}
        
        {/* Upload Progress Indicators */}
        {uploading.map((isUploading, index) => (
          <div key={`uploading-${index}`} className="flex flex-col items-center space-y-2 flex-shrink-0">
            <div className="w-16 h-16 rounded-full bg-carbon border border-ice-white/20 flex items-center justify-center">
              <Loader2 className="w-6 h-6 animate-spin text-neon-red" />
            </div>
            <span className="text-xs text-ice-white/50">Uploading...</span>
          </div>
        ))}
        
        {/* Add Photo Button */}
        {canAddMore && (
          <div className="flex flex-col items-center space-y-2 flex-shrink-0">
            <Button
              variant="outline"
              className={`w-16 h-16 rounded-full border-2 border-dashed transition-all ${
                disabled 
                  ? 'border-ice-white/10 opacity-50 cursor-not-allowed' 
                  : 'border-ice-white/30 hover:border-neon-red hover:bg-neon-red/10'
              }`}
              onClick={disabled ? undefined : onAddPhoto}
              disabled={disabled}
            >
              <Upload className={`w-6 h-6 ${disabled ? 'text-ice-white/30' : 'text-ice-white/70'}`} />
            </Button>
            <span className={`text-xs ${disabled ? 'text-ice-white/30' : 'text-ice-white/70'}`}>
              Add Photo
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoAvatarRow;
